import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import ja from './locales/ja.json'

// Supported locales. Add new languages here + a matching JSON file under locales/.
export const SUPPORTED_LOCALES = ['en', 'ja'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'ja'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    nonExplicitSupportedLngs: true, // ja-JP -> ja
    interpolation: { escapeValue: false }, // React already escapes
    // 使うのは日本のチームなので、明示的に選ばれていない限り日本語で出す。
    // navigator を見ると海外在住メンバーの端末（en-AU など）が英語になってしまい、
    // 毎回切り替えることになるため、検出は「本人が選んだ設定」だけにする。
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'atsm.locale',
    },
  })

export default i18n
